// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"5":"baza-sort","146":"baza-find","265":"baza-search","592":"common"}[chunkId] || chunkId) + "." + {"5":"b1d4a4ad9177493f","146":"65d35793f6f96128","265":"631978426d9f9467","452":"da66af9864d07387","463":"f8067479baaf9b48","592":"61d0f3455ea3d1d5"}[chunkId] + ".js";
};